import { Link } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { useLanguage } from "@/context/LanguageContext";
import { PRODUCTS, coverOf } from "@/lib/shop";

export default function Artists() {
  const { t } = useLanguage();
  return (
    <div className="bg-[#faf8f5] min-h-screen">
      <Nav solid />
      <main className="pt-24 md:pt-32 pb-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <span className="text-xs uppercase tracking-[0.3em] text-[#a89f8e]">
            {t("artists.kicker")}
          </span>
          <h1 className="mt-6 max-w-3xl font-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#111111]">
            {t("artists.title.a")}
            <span className="italic">{t("artists.title.i")}</span>
          </h1>
          <p className="mt-6 max-w-xl text-base md:text-lg font-light leading-relaxed text-[#111111]/70">
            {t("artists.intro")}
          </p>

          <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l gallery-line">
            {PRODUCTS.map((p) => (
              <Link
                key={p.id}
                to={`/artists/${p.id}`}
                data-testid={`artist-card-${p.id}`}
                className="group border-r border-b gallery-line"
              >
                <div className="overflow-hidden bg-white">
                  <img
                    src={coverOf(p)}
                    alt={p.artist?.name || p.name}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03]"
                  />
                </div>
                <div className="px-6 py-6">
                  <h3 className="font-display italic text-xl md:text-2xl tracking-tight text-[#111111]">
                    {p.artist?.name}
                  </h3>
                  <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#a89f8e]">
                    {p.artist?.years}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
